import React from 'react';
import styles from './BottomToolbar.module.css';

type Props = {
  children: React.ReactNode;
  compact?: boolean;
};

export const BottomToolbar: React.FC<Props> = ({ children, compact }) => (
  <div className={compact ? `${styles.container} ${styles.compact}` : styles.container}>
    {React.Children.map(children, (child) => (
      <div className={styles.toolbarItem}>{child}</div>
    ))}
  </div>
);
